import PropTypes from "prop-types";

export const InventarioSectionTitle = ({ title, subtitle }) => {
  return (
    <div className="inv-sec-title-container">
      <p className="inv-sec-title">{title}</p>
      <span className="inv-sec-subtitle"> {subtitle}</span>
    </div>
  );
};

InventarioSectionTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
